import {
    getDirectoryRecordsDictionary,
    getMtsProductsForLead,
} from '~/src/repositories/cms/shared/cms.base.repository';
import {
    getFaqList,
    getMainToolsBlockData,
    getMtsServicesList,
    getRelatedArticlesData,
    getRelatedArticlesViaApi,
    getReviewsAgents,
    getTargetAudienceAgents,
    getUpperBlockData,
} from '~/src/repositories/cms/entities/main';
import { getInstructionData, getInstructionDataViaApi } from '~/src/repositories/cms/entities/profile';
import { getAgentsApiDocumentationData } from '~/src/repositories/cms/entities/agents-api';
import { getInfoBannerData } from '~/src/repositories/cms/entities/leads';
import { getMtsProductsForReferralUrl } from '~/src/repositories/cms/entities/referral-urls';
import { getMtsAboutProductBySefUrl, getMtsKnowledgeBase } from '~/src/repositories/cms/entities/knowledge-base';
import { getMtsProductByAttr, getMtsProductBySefUrl } from '~/src/repositories/cms/entities/products';
import { getAllPartnersProducts } from '~/src/repositories/cms/entities/partners';

export const CmsService = {
    getMtsProductsForLead,
    getAllPartnersProducts,
    getMtsProductBySefUrl,
    getMtsProductByAttr,
    getDirectoryRecordsDictionary,
    getMtsKnowledgeBase,
    getMtsAboutProductBySefUrl,
    getMtsProductsForReferralUrl,
    getInfoBannerData,
    getReviewsAgents,
    getTargetAudienceAgents,
    getMtsServicesList,
    getFaqList,
    getRelatedArticlesData,
    getUpperBlockData,
    getAgentsApiDocumentationData,
    getRelatedArticlesViaApi,
    getInstructionData,
    getInstructionDataViaApi,
    getMainToolsBlockData,
};
